/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CspServiceRoleGroup } from './cspServiceRoleGroup';
import { CspCustomRole } from './cspCustomRole';
import { CspOrganizationRole } from './cspOrganizationRole';


export interface CspUserRoles { 
    /**
     * Organization roles
     */
    organizationRoles?: Array<CspOrganizationRole>;
    /**
     * Service roles
     */
    serviceRoles?: Array<CspServiceRoleGroup>;
    /**
     * Custom roles
     */
    customRoles?: Array<CspCustomRole>;
}

